import React, { useState, useRef, forwardRef, useEffect } from "react";
import { Container, Row, Col, Button, Dropdown } from "react-bootstrap";
import { Chart as ChartJS, LineElement, CategoryScale, LinearScale, PointElement, Tooltip, Filler, BarElement, BarController, ArcElement, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";
import { Card } from "react-bootstrap";
import { Line } from "react-chartjs-2";
import { Bar } from "react-chartjs-2";
import YearPicker from "../common/yearpicker";
import { MapContainer, TileLayer } from "react-leaflet";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
import { getCountApi, getMonthTripApi, getTotalCostApi, getTripsOverviewApi, getVehicleOverviewApi, getCompleteOverviewApi, getOverallCostApi, getVendorBasedTripApi, getTripsApi } from "./dashboard-api";

import "../common/Util.css"; 
import "leaflet/dist/leaflet.css";
//Svgs
import tick from "../../assets/svg/tick.svg";
import customer from "../../assets/svg/customer.svg";
import vendor from "../../assets/svg/vendor.svg";
import vehicle from "../../assets/svg/vehicle.svg";
import stop from "../../assets/svg/stops.svg";
import markerIcon from "../../assets/png/delivery-truck.png";
import Sidebar from "../common/Sidebar";
import { Navbar } from "../common/Navbar";

ChartJS.register(LineElement, CategoryScale, LinearScale, PointElement, Tooltip, Filler, BarElement, BarController, ArcElement, Legend);
export function Dashboard() {
  const [count, setCount] = useState(0);
  const [totalCost, setTotalCost] = useState(0);
  const [monthTrip, setMonthTrip] = useState([]);
  const [monthCost, setMonthCost] = useState([]);
  const [tripsOverview, setTripsOverview] = useState([]);
  const [vehicleOverview, setVehicleOverview] = useState([]);
  const [completeOverview, setCompleteOverview] = useState([]);
  const [overallCost, setOverallCost] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [trips, setTrips] = useState([]);

  const currentYear = new Date(); // full Date object
  const [selectedTripYear, setSelectedTripYear] = useState(currentYear);
  const [selectedCostYear, setSelectedCostYear] = useState(currentYear);
  //Api Call
  useEffect(() => {
    const fetchCount = async () => {
      try {
        const response = await getCountApi();
        setCount(response?.data?.count ?? 0);
      } catch (err) {
        console.error("Error fetching count:", err);
      }
    };
    fetchCount();
  }, []);

  useEffect(() => {
    const fetchTrips = async () => {
      try {
        const payload = {
          period: selectedTripYear?.getFullYear?.() ?? new Date().getFullYear(),
        };
        const response = await getMonthTripApi(payload);
        setMonthTrip(response?.data?.trips ?? []);
      } catch (err) {
        console.error("Error fetching trips:", err);
      }
    };
    fetchTrips();
  }, [selectedTripYear]);
  // ...existing code...
  useEffect(() => {
    const fetchCosts = async () => {
      try {
        const payload = {
          period: selectedCostYear?.getFullYear?.() ?? new Date().getFullYear(),
        };
        const response = await getTotalCostApi(payload);
        setMonthCost(response?.data?.trips ?? []);
      } catch (err) {
        console.error("Error fetching costs:", err);
      }
    };
    fetchCosts();
  }, [selectedCostYear]);

  useEffect(() => {
    const tripsOverview = async () => {
      try {
        const response = await getTripsOverviewApi();
        setTripsOverview(response?.data?.overview || {});
      } catch (err) {
        console.error("Error fetching count:", err);
      }
    };
    tripsOverview();
  }, []);

  useEffect(() => {
    const vehicleOverview = async () => {
      try {
        const response = await getVehicleOverviewApi();
        setVehicleOverview(response?.data?.overview || {});
      } catch (err) {
        console.error("Error fetching count:", err);
      }
    };
    vehicleOverview();
  }, []);
  useEffect(() => {
    const completionOverview = async () => {
      try {
        const response = await getCompleteOverviewApi();
        setCompleteOverview(response?.data?.overview || {});
      } catch (err) {
        console.error("Error fetching count:", err);
      }
    };
    completionOverview();
  }, []);

  useEffect(() => {
    const vendorBased = async () => {
      try {
        const response = await getVendorBasedTripApi();
        setVendors(response?.data?.data || []);
      } catch (err) {
        console.error("Error fetching count:", err);
      }
    };
    vendorBased();
  }, []);

  // Fetch vehicle live locations
  useEffect(() => {
    const fetchVehicleLocations = async () => {
      try {
        const response = await getTripsApi();
        setTrips(response?.data?.trip || []);
      } catch (err) {
        console.error("Error fetching vehicle locations:", err);
      }
    };

    fetchVehicleLocations();
    // Refresh every 30 seconds
    const interval = setInterval(fetchVehicleLocations, 60000);

    return () => clearInterval(interval);
  }, []);
  // Live View

  const [selectedVendor, setSelectedVendor] = useState("All"); // Default selected vendor
  const [selectedVendorYear, setSelectedVendorYear] = useState(currentYear);
  //Customized ToolTip
  const externalTooltipHandler = (context) => {
    const { chart, tooltip } = context;
    let tooltipEl = chart.canvas.parentNode.querySelector("div.custom-chart-tooltip");
    // Create tooltip
    if (!tooltipEl) {
      tooltipEl = document.createElement("div");
      tooltipEl.classList.add("custom-chart-tooltip");
      tooltipEl.style.background = "white";
      tooltipEl.style.borderRadius = "8px";
      tooltipEl.style.border = "1px solid #ddd";
      tooltipEl.style.pointerEvents = "none";
      tooltipEl.style.position = "absolute";
      tooltipEl.style.padding = "12px 16px";
      tooltipEl.style.boxShadow = "0 5px 15px rgba(0, 0, 0, 0.1)";
      tooltipEl.style.transition = "opacity 0.2s ease";
      tooltipEl.style.zIndex = 1000;

      chart.canvas.parentNode.appendChild(tooltipEl);
    }
    if (tooltip.opacity === 0) {
      tooltipEl.style.opacity = 0;
      return;
    }

    // Dynamic Content
    const dp = tooltip.dataPoints && tooltip.dataPoints[0];
    if (!dp) {
      tooltipEl.style.opacity = 0;
      return;
    }
    const raw = dp.raw || {};
    const dateLabel = raw.x ?? dp.label;
    const tripsValue = raw.y ?? dp.formattedValue;

    const isDown = raw.decrease ?? false;
    const diff = raw.diff ?? 0;

    const arrow = isDown ? "↓" : "↑";
    const arrowColor = isDown ? "#EF4444" : "#00C170";
    const percentageText = diff ?? 0;

    tooltipEl.innerHTML = `
      <div style="width:200px;">
        <div style="font-weight:700;font-size:13px;color:#000;">Total trips</div>
        <div style="font-size:12px;color:#66737E;margin-bottom:1px;">${dateLabel}, 2023</div>
        <div style="font-weight:600;font-size:16px;color:#3469E7;margin-bottom:8px;">${tripsValue}</div>

        <div style="display:flex;align-items:center;">
          <span style="
            background:${arrowColor};
            color:#fff;
            padding:4px 4px;
            border-radius:9999px;
            font-weight:600;
            font-size:11px;
            margin-right:8px;
          ">${arrow} ${percentageText}</span>

          <span style="font-size:12px;color:#4b5563;font-weight:400;">
            From previous month
          </span>
        </div>
      </div>
    `;

    // Chart offsets
    const { offsetLeft: posX, offsetTop: posY } = chart.canvas;

    const tooltipWidth = 200;
    const padding = 20;

    const chartHeight = chart.chartArea.bottom - chart.chartArea.top;
    const centeredY = posY + chart.chartArea.top + chartHeight / 2 - 50;

    const cursorX = tooltip.caretX;
    const chartLeft = chart.chartArea.left;
    const chartRight = chart.chartArea.right;

    let left;

    if (cursorX < chartLeft + (chartRight - chartLeft) * 0.2) {
      left = posX + cursorX + padding;
    } else if (cursorX > chartLeft + (chartRight - chartLeft) * 0.7) {
      left = posX + cursorX - tooltipWidth - padding;
    } else {
      left = posX + cursorX + padding;
    }

    tooltipEl.style.top = `${centeredY}px`;
    tooltipEl.style.left = `${left}px`;
    tooltipEl.style.opacity = 1;
  };
  //Vertical Line
  const verticalLinePlugin = {
    id: "verticalLine",
    afterDraw: (chart, args, options) => {
      const tooltip = chart.tooltip;
      const activeElements = tooltip && typeof tooltip.getActiveElements === "function" ? tooltip.getActiveElements() : [];
      if (!activeElements || activeElements.length === 0) {
        return;
      }

      const ctx = chart.ctx;
      ctx.save();

      let xCoord;
      const first = activeElements[0];
      if (first && first.element && typeof first.element.x === "number") {
        xCoord = first.element.x;
      } else {
        xCoord = tooltip.caretX || (chart.chartArea.left + chart.chartArea.right) / 2;
      }

      ctx.strokeStyle = options.color || "#172B4D";
      ctx.lineWidth = options.width || 1;

      const chartArea = chart.chartArea;
      const top = chartArea.top;
      const bottom = chartArea.bottom;

      ctx.beginPath();
      ctx.moveTo(xCoord, top);
      ctx.lineTo(xCoord, bottom);
      ctx.stroke();

      ctx.restore();
    },
  };
  ChartJS.register(verticalLinePlugin);
  // Chart1
  const data = {
    labels: monthTrip.map((item) => item.month),
    datasets: [
      {
        label: "Trips",
        data: monthTrip.map((item) => ({
          x: item.month,
          y: Number(item.total || 0),
          diff: item.diff,
          decrease: item.decrease,
        })),
        borderColor: "#2563eb",
        borderDash: [6, 6],
        pointBackgroundColor: "#2563eb",
        pointRadius: 5,
        tension: 0.3,
        fill: false,
      },
    ],
  };
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      tooltip: {
        enabled: false,
        external: externalTooltipHandler,
      },
      verticalLine: {
        width: 1,
        color: "#172B4D",
      },
      legend: { display: false },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: { color: "#6b7280" },
        grid: { color: "#e5e7eb" },
      },
      x: {
        ticks: { color: "#6b7280" },
        grid: { display: false },
      },
    },
  };
  //Chart 2
  const costData = {
    labels: monthCost.map((item) => item.month),
    datasets: [
      {
        label: "Total Cost",
        data: monthCost.map((item) => ({
          x: item.month,
          y: Number(item.total || 0),
          diff: item.diff,
          decrease: item.decrease,
        })),
        backgroundColor: (ctx) => {
          const gradient = ctx.chart.ctx.createLinearGradient(0, 0, 0, 300);
          gradient.addColorStop(0, "rgba(52, 105, 231, 1)");
          gradient.addColorStop(1, "rgba(52, 105, 231, 0.2)");
          return gradient;
        },
        borderRadius: 10,
        barThickness: 24,
      },
    ],
  };
  const costOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        enabled: false,
        external: externalTooltipHandler,
      },
      verticalLine: false,
    },
    scales: {
      y: {
        ticks: { color: "#9CA3AF" },
        grid: { color: "#E5E7EB", drawBorder: false },
        beginAtZero: true,
      },
      x: {
        ticks: { color: "#6B7280" },
        grid: { display: false },
      },
    },
    hover: {
      mode: "index",
      intersect: false,
    },
  };
  //Live View
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAP_KEY,
  });
  const [center, setCenter] = useState({
    lat: 13.0843,
    lng: 80.2705,
  });

  // State for hover tooltip
  const [hoveredVehicle, setHoveredVehicle] = useState(null);
  //Trips OverView
  const open = tripsOverview?.created || 0;
  const inProgress = tripsOverview?.in_progress || 0;
  const completed = tripsOverview?.completed || 0;

  const total = open + inProgress + completed;

  const openWidth = (open / total) * 100;
  const inProgressWidth = (inProgress / total) * 100;
  const completedWidth = (completed / total) * 100;
  //Overview
  const tripData = {
    labels: ["On time", "Delayed", "Stopped"],
    datasets: [
      {
        data: [completeOverview?.ontime || 0, completeOverview?.delayed || 0, completeOverview?.stopped || 0],
        backgroundColor: ["#6B8BFE", "#E6ECF8", "#0A0F1A"],
        borderWidth: 0,
        cutout: "72%",
      },
    ],
  };
  const tripOptions = {
    plugins: {
      legend: { display: false },
      tooltip: { enabled: true },
      verticalLine: false,
    },
  };
  //Vehicle Over view
  const active = vehicleOverview?.active || 0;
  const idle = vehicleOverview?.idle || 0;
  const maintenance = vehicleOverview?.under_mainten || 0;

  const vehicleStats = { active, idle, maintenance };

  const barsRef = useRef(null);
  const [maxBarHeight, setMaxBarHeight] = useState(130); // fallback height

  useEffect(() => {
    const measure = () => {
      if (barsRef.current) {
        const available = Math.max(60, barsRef.current.clientHeight - 20);
        setMaxBarHeight(available);
      }
    };
    measure();
    window.addEventListener("resize", measure);
    return () => window.removeEventListener("resize", measure);
  }, []);

  const values = [vehicleStats.active, vehicleStats.idle, vehicleStats.maintenance];
  const maxValue = Math.max(...values, 1);

  const barHeights = values.map((v) => (v / maxValue) * maxBarHeight);
  //cost per trip
  const getInitials = (name) => {
    if (!name) return "";
    return name
      .split(" ")
      .map((w) => w[0])
      .join("")
      .substring(0, 2)
      .toUpperCase();
  };

  //cost over view
  const [activeTab, setActiveTab] = useState("fuel");

  useEffect(() => {
    const fetchOverallCost = async () => {
      try {
        const payload = {
          type: activeTab,
          period: selectedVendorYear?.getFullYear?.() ?? new Date().getFullYear(),
        };
        const response = await getOverallCostApi(payload);
        setOverallCost(response?.data?.data ?? []);
      } catch (err) {
        console.error("Error fetching overall cost:", err);
      }
    };

    fetchOverallCost();
  }, [activeTab, selectedVendorYear]);
  const costMonths = overallCost.map((item) => item.month);
  const costValues = overallCost.map((item) => item.cost);

  const costDatas = {
    labels: costMonths,
    datasets: [
      {
        label: "Cost",
        data: costValues,
        backgroundColor: "#2B61F0",
        borderRadius: 12,
        barThickness: 28,
      },
    ],
  };

  const CostOptions = {
    responsive: true,
    plugins: {
      legend: { display: false },
      tooltip: {
        backgroundColor: "#000",
        padding: 10,
        titleColor: "#fff",
        bodyColor: "#fff",
        displayColors: false,
        callbacks: {
          // Dynamic tooltip fix
          label: (context) => `₹${context.raw.toLocaleString()}`,
        },
      },
      verticalLine: false,
    },
    scales: {
      y: {
        beginAtZero: true,
        grid: {
          color: "#EAEAEA",
          drawBorder: false,
        },
        ticks: { color: "#9CA3AF" },
      },
      x: {
        grid: { display: false },
        ticks: {
          color: "#7A7A7A",
          font: { size: 12 },
        },
      },
    },
  };

  return (
    <div className="d-flex ">
      <Sidebar currentfile="Dashboard" />
      <div
        className="rounded-4 flex-grow-1  "
        style={{
          width: "calc(100vw - 80px)",
          height: "calc(100vh)",
        }}
      >
        {/* Top Bar */}
        {/* <Row className="align-items-center mb-4">
        <Col>
          <h6 style={{ color: "#7a7a7a", margin: 0 }}>DASHBOARD</h6>
        </Col>
        <Col xs="auto">
          <Dropdown>
            <Dropdown.Toggle
              variant="light"
              style={{
                border: "1px solid #ddd",
                backgroundColor: "#fff",
                borderRadius: "8px",
                fontSize: "14px",
              }}
            >
              Filters
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item>Last 7 Days</Dropdown.Item>
              <Dropdown.Item>Last 3 Months</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </Col>
        <Col xs="auto">
          <Dropdown>
            <Dropdown.Toggle
              variant="light"
              style={{
                border: "1px solid #ddd",
                backgroundColor: "#fff",
                borderRadius: "8px",
                fontSize: "14px",
              }}
            >
              Last 3 Months
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item>Last Month</Dropdown.Item>
              <Dropdown.Item>Last 6 Months</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </Col>
        <Col xs="auto">
          <Button
            style={{
              backgroundColor: "#007bff",
              border: "none",
              borderRadius: "8px",
              padding: "8px 16px",
              fontWeight: 500,
            }}
          >
            Download as PDF
          </Button>
        </Col>
      </Row> */}
        <Navbar pageTitle="Dashboard" />
        <div className="bg-half-white p-2 scroll-hidden" style={{ height: "calc(100vh - 56px)" }}>
          {/* Dashboard Cards */}
          <Row className="g-3">
            <Col md={3}>
              <div
                style={{
                  backgroundColor: "#FFFFFF",
                  borderRadius: "12px",
                  padding: "16px",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
                }}
              >
                <div className="d-flex" style={{ justifyContent: "space-between" }}>
                  <div>
                    <div className="fs-13 fw-400 textltcolor">Trips</div>
                    <div className="fs-24 fw-500 textBlack">{count.trips?.total ?? 0}</div>
                  </div>
                  <div
                    style={{
                      padding: 8,
                      backgroundColor: "#F3F6FF",
                      borderRadius: 100,
                    }}
                  >
                    <img src={tick} alt="icon" style={{ width: 40 }} />
                  </div>
                </div>
                <hr style={{ margin: "10px 0", borderTop: "2px solid #EBEBEB" }} />

                <div style={{ fontSize: "14px", marginTop: "8px" }}>
                  <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <div
                        style={{
                          height: "10px",
                          width: "10px",
                          backgroundColor: "#5CCC89",
                          borderRadius: "50%",
                          display: "inline-block",
                          marginRight: "8px",
                        }}
                      ></div>
                      <div className="fs-13 fw-400 textltcolor">Completed</div>
                    </div>
                    <div className="fs-16 fw-500 textltcolor" style={{ color: "#172B4D" }}>
                      {count.trips?.completed ?? 0}
                    </div>
                  </div>
                  <div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <div
                          style={{
                            height: "10px",
                            width: "10px",
                            backgroundColor: "#81A6FF",
                            borderRadius: "50%",
                            display: "inline-block",
                            marginRight: "8px",
                          }}
                        ></div>
                        <div className="fs-13 fw-400 textltcolor">InProgress</div>
                      </div>
                      <div className="fs-16 fw-500 textltcolor" style={{ color: "#172B4D" }}>
                        {count.trips?.inprogress ?? 0}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            {/* Customers Orders */}
            <Col md={3}>
              <div
                style={{
                  backgroundColor: "#FFFFFF",
                  borderRadius: "12px",
                  padding: "16px",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
                }}
              >
                <div className="d-flex" style={{ justifyContent: "space-between" }}>
                  <div>
                    <div className="fs-13 fw-400 textltcolor">Customers</div>
                    <div className="fs-24 fw-500 textBlack">{count.customers?.total ?? 0}</div>
                  </div>
                  <div
                    style={{
                      padding: 8,
                      backgroundColor: "#F3F6FF",
                      borderRadius: 100,
                    }}
                  >
                    <img src={customer} alt="icon" style={{ width: 40 }} />
                  </div>
                </div>
                <hr style={{ margin: "10px 0", borderTop: "2px solid #EBEBEB" }} />

                <div style={{ fontSize: "14px", marginTop: "8px" }}>
                  <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <div
                        style={{
                          height: "10px",
                          width: "10px",
                          backgroundColor: "#5CCC89",
                          borderRadius: "50%",
                          display: "inline-block",
                          marginRight: "8px",
                        }}
                      ></div>
                      <div className="fs-13 fw-400 textltcolor">Active</div>
                    </div>
                    <div className="fs-16 fw-500 textltcolor" style={{ color: "#172B4D" }}>
                      {count.customers?.active ?? 0}
                    </div>
                  </div>
                  <div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <div
                          style={{
                            height: "10px",
                            width: "10px",
                            backgroundColor: "#F68888",
                            borderRadius: "50%",
                            display: "inline-block",
                            marginRight: "8px",
                          }}
                        ></div>
                        <div className="fs-13 fw-400 textltcolor">Inactive</div>
                      </div>
                      <div className="fs-16 fw-500 textltcolor" style={{ color: "#172B4D" }}>
                        {count.customers?.inactive ?? 0}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            {/* vendor Orders */}
            <Col md={3}>
              <div
                style={{
                  backgroundColor: "#FFFFFF",
                  borderRadius: "12px",
                  padding: "16px",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
                }}
              >
                <div className="d-flex" style={{ justifyContent: "space-between" }}>
                  <div>
                    <div className="fs-13 fw-400 textltcolor">Vendors</div>
                    <div className="fs-24 fw-500 textBlack">{count.vendors?.total ?? 0}</div>
                  </div>
                  <div
                    style={{
                      padding: 8,
                      backgroundColor: "#F3F6FF",
                      borderRadius: 100,
                    }}
                  >
                    <img src={vendor} alt="icon" style={{ width: 40 }} />
                  </div>
                </div>
                <hr style={{ margin: "10px 0", borderTop: "2px solid #EBEBEB" }} />

                <div style={{ fontSize: "14px", marginTop: "8px" }}>
                  <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <div
                        style={{
                          height: "10px",
                          width: "10px",
                          backgroundColor: "#5CCC89",
                          borderRadius: "50%",
                          display: "inline-block",
                          marginRight: "8px",
                        }}
                      ></div>
                      <div className="fs-13 fw-400 textltcolor">Active</div>
                    </div>
                    <div className="fs-16 fw-500 textltcolor" style={{ color: "#172B4D" }}>
                      {count.vendors?.active ?? 0}
                    </div>
                  </div>
                  <div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <div
                          style={{
                            height: "10px",
                            width: "10px",
                            backgroundColor: "#F68888",
                            borderRadius: "50%",
                            display: "inline-block",
                            marginRight: "8px",
                          }}
                        ></div>
                        <div className="fs-13 fw-400 textltcolor">Inactive</div>
                      </div>
                      <div className="fs-16 fw-500 textltcolor" style={{ color: "#172B4D" }}>
                        {count.vendors?.inactive ?? 0}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            {/* Purchase Orders */}
            <Col md={3}>
              <div
                style={{
                  gap: "24px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  backgroundColor: "#FFFFFF",
                  borderRadius: "12px",
                  padding: "10px",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
                }}
              >
                <div className="d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center gap-2">
                    <div
                      style={{
                        padding: 8,
                        backgroundColor: "#F3F6FF",
                        borderRadius: 100,
                      }}
                    >
                      <img src={stop} alt="icon" style={{ width: 40 }} />
                    </div>
                    <div className="fs-13 fw-400 textltcolor">Stops</div>
                  </div>
                  <div>
                    <div className="fs-24 fw-500 textBlack">{count.stops ?? 0}</div>
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center gap-2">
                    <div
                      style={{
                        padding: 8,
                        backgroundColor: "#F3F6FF",
                        borderRadius: 100,
                      }}
                    >
                      <img src={vehicle} alt="icon" style={{ width: 40 }} />
                    </div>
                    <div className="fs-13 fw-400 textltcolor">Vehicle</div>
                  </div>
                  <div>
                    <div className="fs-24 fw-500 textBlack">{count.vehicle ?? 0}</div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          <Row className="align-items-center mb-2 mt-3">
            <Col md={6}>
              <div
                className="p-4 shadow-sm "
                style={{
                  borderRadius: "20px",
                  backgroundColor: "#FFFFFF",
                  border: "1px solid #EBEBEB",
                }}
              >
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h5 className="fw-bold m-0">Trip created by month</h5>
                  <div className="year-picker-btn">
                    <YearPicker selectedYear={selectedTripYear} setSelectedYear={setSelectedTripYear} />
                  </div>
                </div>
                <div style={{ height: "300px" }}>
                  <Line data={data} options={options} />
                </div>
              </div>
            </Col>

            <Col md={6}>
              <div
                className="p-4 shadow-sm "
                style={{
                  borderRadius: "20px",
                  backgroundColor: "#FFFFFF",
                  border: "1px solid #EBEBEB",
                }}
              >
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h5 className="fw-bold m-0">Total Trip cost</h5>
                  <YearPicker selectedYear={selectedCostYear} setSelectedYear={setSelectedCostYear} />
                </div>
                <div style={{ height: "300px" }}>
                  <Bar data={costData} options={costOptions} />
                </div>
              </div>
            </Col>
          </Row>
          {/* Trips over view */}
          <Row className="align-items-center mb-2 mt-3">
            <Col md={8}>
              <div className="bg-white rounded-4 p-3 h-300">
                <div className="d-flex flex-wrap justify-content-between align-items-center mb-3">
                  <div>
                    <p className="m-0 fs-16 fw-700">Live View</p>
                    {/* <p className="m-0 fs-12 fw-400" style={{ color: "#66737E" }}>
                      {trips.filter((trip) => trip.latitude && trip.longitude && trip.latitude !== "" && trip.longitude !== "").length} vehicles with active GPS
                    </p> */}
                  </div>
                </div>
                <div
                  style={{
                    width: "100%",
                    height: "300px",
                    borderRadius: "12px",
                    overflow: "hidden",
                    position: "relative",
                  }}
                >
                  {isLoaded && (
                    <GoogleMap mapContainerStyle={{ width: "100%", height: 325 }} center={center} zoom={14}>
                      {trips &&
                        trips.length > 0 &&
                        trips
                          .filter((trip) => trip.latitude && trip.longitude && trip.latitude !== "" && trip.longitude !== "")
                          .map((trip) => (
                            <Marker
                              key={trip.id}
                              position={{
                                lat: parseFloat(trip.latitude),
                                lng: parseFloat(trip.longitude),
                              }}
                              icon={{
                                url: markerIcon,
                                scaledSize: new window.google.maps.Size(20, 60),
                              }}
                              onMouseOver={() => setHoveredVehicle(trip)}
                              onMouseOut={() => setHoveredVehicle(null)}
                            />
                          ))}
                    </GoogleMap>
                  )}

                  {/* Hover Tooltip */}
                  {hoveredVehicle && (
                    <div
                      style={{
                        position: "absolute",
                        top: "10px",
                        right: "10px",
                        background: "white",
                        padding: "12px 16px",
                        borderRadius: "8px",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                        zIndex: 1000,
                        minWidth: "200px",
                      }}
                    >
                      <div style={{ fontWeight: 600, fontSize: "14px", color: "#0B1A39", marginBottom: "8px" }}>{hoveredVehicle.vehicle_name}</div>
                      <div style={{ fontSize: "12px", color: "#66737E", marginBottom: "4px" }}>
                        <strong>Trip ID:</strong> {hoveredVehicle.trip_id}
                      </div>
                      <div style={{ fontSize: "12px", color: "#66737E", marginBottom: "4px" }}>
                        <strong>License:</strong> {hoveredVehicle.license_plate}
                      </div>
                      <div style={{ fontSize: "12px", color: "#66737E", marginBottom: "4px" }}>
                        <strong>Status:</strong>{" "}
                        <span
                          style={{
                            color: hoveredVehicle.status === "Created" ? "#FFA500" : hoveredVehicle.vehicle_status ? "#00C170" : "#EF4444",
                          }}
                        >
                          {hoveredVehicle.status}
                        </span>
                      </div>
                      {hoveredVehicle.current_stop && (
                        <div style={{ fontSize: "12px", color: "#66737E", marginBottom: "4px" }}>
                          <strong>Current:</strong> {hoveredVehicle.current_stop}
                        </div>
                      )}
                      {hoveredVehicle.next_stop && (
                        <div style={{ fontSize: "12px", color: "#66737E" }}>
                          <strong>Next:</strong> {hoveredVehicle.next_stop}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </Col>
            <Col md={4}>
              <div
                style={{
                  background: "#FFFFFF",
                  borderRadius: "20px",
                  padding: "24px",
                  width: "100%",
                  boxShadow: "0 2px 12px rgba(0,0,0,0.04)",
                }}
              >
                <div className="fs-16 fw-700 mb-2" style={{ textAlign: "left" }}>
                  Trips overview
                </div>
                <div
                  className="fs-27 fw-600 mt-3 mb-3"
                  style={{
                    marginTop: "10px",
                    color: "#0B1A39",
                    textAlign: "left",
                  }}
                >
                  {tripsOverview?.total}
                </div>

                <div
                  className="fs-12 fw-400 mt-3 mb-3"
                  style={{
                    color: "#32A852",
                    marginTop: "6px",
                    textAlign: "left",
                  }}
                >
                  {tripsOverview?.diff_percent}% <span style={{ color: "#626F86" }}>increased from last month</span>
                </div>

                <div
                  className="mt-3 mb-3"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    background: "#F6F7F9",
                    borderRadius: "40px",
                    padding: "10px 18px",
                    gap: "10px",
                    width: "fit-content",
                    textAlign: "left",
                  }}
                >
                  <div
                    style={{
                      height: "15px",
                      width: "5px",
                      background: "#1F9E4F",
                      borderRadius: "20px",
                    }}
                  ></div>

                  <span
                    style={{
                      fontSize: "14px",
                      fontWeight: 400,
                      color: "#0B1A39",
                    }}
                  >
                    Increased amount
                  </span>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      background: "#FFFFFF",
                      padding: "2px 10px",
                      borderRadius: "40px",
                    }}
                  >
                    <span
                      style={{
                        color: "#1F9E4F",
                        fontSize: "12px",
                        fontWeight: 400,
                      }}
                    >
                      ↑
                    </span>
                    <span
                      style={{
                        color: "#0B1A39",
                        fontSize: "12px",
                        fontWeight: 400,
                      }}
                    >
                      {" "}
                      {tripsOverview?.diff}
                    </span>
                  </div>
                </div>
                <div
                  className="mb-3 mt-4"
                  style={{
                    height: "14px",
                    width: "100%",
                    borderRadius: "30px",
                    background: "#E8EEFF",
                    display: "flex",
                    overflow: "hidden",
                    marginBottom: "25px",
                  }}
                >
                  <div style={{ width: `${openWidth}%`, background: "#225AF4" }} />
                  <div
                    style={{
                      width: `${inProgressWidth}%`,
                      background: "#5D92FF",
                    }}
                  />
                  <div
                    style={{
                      width: `${completedWidth}%`,
                      background: "#BFD6FF",
                    }}
                  />
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "12px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <div
                      style={{
                        height: "12px",
                        width: "12px",
                        borderRadius: "50%",
                        background: "#225AF4",
                      }}
                    />
                    <span
                      style={{
                        fontSize: "14px",
                        fontWeight: 400,
                        color: "#6E7C91",
                      }}
                    >
                      Open
                    </span>
                  </div>
                  <div
                    style={{
                      fontSize: "16px",
                      fontWeight: 500,
                      color: "#0B1A39",
                    }}
                  >
                    {open}
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "12px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <div
                      style={{
                        height: "12px",
                        width: "12px",
                        borderRadius: "50%",
                        background: "#5D92FF",
                      }}
                    />
                    <span
                      style={{
                        fontSize: "14px",
                        fontWeight: 400,
                        color: "#6E7C91",
                      }}
                    >
                      In Progress
                    </span>
                  </div>
                  <div
                    style={{
                      fontSize: "16px",
                      fontWeight: 500,
                      color: "#0B1A39",
                    }}
                  >
                    {inProgress}
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <div
                      style={{
                        height: "12px",
                        width: "12px",
                        borderRadius: "50%",
                        background: "#BFD6FF",
                      }}
                    />
                    <span
                      style={{
                        fontSize: "14px",
                        fontWeight: 400,
                        color: "#6E7C91",
                      }}
                    >
                      Completed
                    </span>
                  </div>
                  <div
                    style={{
                      fontSize: "16px",
                      fontWeight: 500,
                      color: "#0B1A39",
                    }}
                  >
                    {completed}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          {/* OverView */}
          <Row className="align-items-center mb-2 mt-3">
            <Col md={3}>
              <div
                className="p-4 shadow-sm "
                style={{
                  borderRadius: "20px",
                  backgroundColor: "#FFFFFF",
                  border: "1px solid #EBEBEB",
                }}
              >
                {/* Title */}
                <div
                  style={{
                    fontWeight: 700,
                    fontSize: "18px",
                    color: "#0B1A39",
                  }}
                >
                  Vehicle overview
                </div>

                {/* Bars + Total Vehicles */}
                <div className="d-flex justify-content-between align-items-start mt-3">
                  {/* Bars */}
                  <div
                    ref={barsRef}
                    className="d-flex"
                    style={{
                      gap: "20px",
                      alignItems: "flex-end",
                      minHeight: 100,
                    }}
                  >
                    <div
                      style={{
                        width: "50px",
                        height: `${barHeights[0]}px`,
                        background: "#356DF6",
                        borderRadius: "8px",
                        transition: "height 300ms",
                      }}
                    />
                    <div
                      style={{
                        width: "50px",
                        height: `${barHeights[1]}px`,
                        background: "#7CA7FF",
                        borderRadius: "8px",
                        transition: "height 300ms",
                      }}
                    />
                    <div
                      style={{
                        width: "50px",
                        height: `${barHeights[2]}px`,
                        background: "#D7E2FF",
                        borderRadius: "8px",
                        transition: "height 300ms",
                      }}
                    />
                  </div>

                  {/* Total Vehicles */}
                  <div className="text-center">
                    <div
                      style={{
                        width: "48px",
                        height: "48px",
                        borderRadius: "50%",
                        background: "#EEF3FF",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        margin: "auto",
                      }}
                    >
                      <img src="https://cdn-icons-png.flaticon.com/512/743/743131.png" width="22" height="22" alt="vehicle" />
                    </div>
                    <div
                      style={{
                        fontSize: "13px",
                        marginTop: "5px",
                        color: "#6A7485",
                      }}
                    >
                      Total vehicles
                    </div>
                    <div
                      style={{
                        fontSize: "22px",
                        fontWeight: 700,
                        color: "#0B1A39",
                      }}
                    >
                      {vehicleOverview?.total}
                    </div>
                  </div>
                </div>

                {/* Status List */}
                <div className="mt-3 fs-14 fw-400">
                  {/* Active */}
                  <div className="d-flex align-items-center mb-3">
                    <div
                      style={{
                        width: "12px",
                        height: "12px",
                        borderRadius: "50%",
                        background: "#356DF6",
                        marginRight: "12px",
                      }}
                    ></div>
                    <span style={{ color: "#6A7485" }}>Active</span>
                    <b className="ms-auto" style={{ color: "#0B1A39" }}>
                      45
                    </b>
                  </div>

                  {/* Idle */}
                  <div className="d-flex align-items-center mb-3">
                    <div
                      style={{
                        width: "12px",
                        height: "12px",
                        borderRadius: "50%",
                        background: "#7CA7FF",
                        marginRight: "12px",
                      }}
                    ></div>
                    <span style={{ color: "#6A7485" }}>Idle</span>
                    <b className="ms-auto" style={{ color: "#0B1A39" }}>
                      60
                    </b>
                  </div>

                  {/* Under Maintenance */}
                  <div className="d-flex align-items-center">
                    <div
                      style={{
                        width: "12px",
                        height: "12px",
                        borderRadius: "50%",
                        background: "#D7E2FF",
                        marginRight: "12px",
                      }}
                    ></div>
                    <span style={{ color: "#6A7485" }}>Under Maintenance</span>
                    <b className="ms-auto" style={{ color: "#0B1A39" }}>
                      38
                    </b>
                  </div>
                </div>
              </div>
            </Col>

            <Col md={3}>
              <div
                className="p-4 shadow-sm "
                style={{
                  borderRadius: "20px",
                  backgroundColor: "#FFFFFF",
                  border: "1px solid #EBEBEB",
                }}
              >
                <div
                  style={{
                    fontWeight: 700,
                    fontSize: "18px",
                    color: "#0B1A39",
                    textAlign: "left",
                  }}
                >
                  Trip completion overview
                </div>

                <div className="d-flex justify-content-center mt-3">
                  <div style={{ width: "100px", position: "relative" }}>
                    <Doughnut data={tripData} options={tripOptions} />

                    {/* Center Text */}
                    <div
                      style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -55%)",
                        textAlign: "center",
                        fontWeight: 400,
                        fontSize: "16px",
                        color: "#172B4D",
                      }}
                    >
                      {completeOverview.total}
                      <div
                        style={{
                          fontSize: "11px",
                          fontWeight: 300,
                          color: "#8790A1",
                        }}
                      >
                        Total
                      </div>
                    </div>
                  </div>
                </div>

                {/* Legend */}
                <div className="mt-3 fs-14 fw-400">
                  <div className="d-flex align-items-center mb-3">
                    <div
                      style={{
                        width: "12px",
                        height: "12px",
                        borderRadius: "50%",
                        background: "#7FA3FB",
                        marginRight: "10px",
                      }}
                    ></div>
                    <span style={{ color: "#8790A1" }}>On time</span>
                    <b className="ms-auto fs-16 fw-600" style={{ color: "#19324C" }}>
                      {completeOverview.ontime}
                    </b>
                  </div>

                  <div className="d-flex align-items-center mb-3">
                    <div
                      style={{
                        width: "12px",
                        height: "12px",
                        borderRadius: "50%",
                        background: "#DEE5ED",
                        marginRight: "10px",
                      }}
                    ></div>
                    <span style={{ color: "#8790A1" }}>Delayed</span>
                    <b className="ms-auto fs-16 fw-600" style={{ color: "#19324C" }}>
                      {completeOverview.delayed}
                    </b>
                  </div>

                  <div className="d-flex align-items-center">
                    <div
                      style={{
                        width: "12px",
                        height: "12px",
                        borderRadius: "50%",
                        background: "#1A202F",
                        marginRight: "10px",
                      }}
                    ></div>
                    <span style={{ color: "#8790A1" }}>Stopped</span>
                    <b className="ms-auto fs-16 fw-600" style={{ color: "#19324C" }}>
                      {completeOverview.stopped}
                    </b>
                  </div>
                </div>
              </div>
            </Col>

            <Col md={6}>
              <div
                className="p-4 shadow-sm "
                style={{
                  borderRadius: "20px",
                  backgroundColor: "#FFFFFF",
                  border: "1px solid #EBEBEB",
                }}
              >
                <div style={{ fontWeight: 700, textAlign: "left" }}>Cost per Vendor</div>

                {/* Scrollable container */}
                <div
                  style={{
                    maxHeight: "230px",
                    overflowY: "auto",
                    marginTop: "10px",
                    paddingRight: "5px",
                  }}
                >
                  {vendors.map((i, index) => {
                    const companyName = i.name ?? "--";
                    const initials = getInitials(companyName);
                    const amount = Number(i.amount).toLocaleString("en-IN");

                    return (
                      <div
                        key={index}
                        className="p-3 mb-3 shadow-sm"
                        style={{
                          borderRadius: "16px",
                          backgroundColor: "#F8F8F8",
                        }}
                      >
                        <div className="d-flex justify-content-between align-items-center">
                          <div className="d-flex align-items-center" style={{ gap: "12px" }}>
                            {/* INITIALS CIRCLE */}
                            <div
                              style={{
                                width: "40px",
                                height: "40px",
                                background: "#FFFFFF",
                                borderRadius: "50%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                fontWeight: 700,
                                color: "#3469E7",
                              }}
                            >
                              {initials}
                            </div>

                            {/* COMPANY NAME + TRIP ID */}
                            <div>
                              <div className="fs-14 fw-600" style={{ textAlign: "left", marginLeft: 10 }}>
                                {companyName}
                              </div>

                              <div className="fs-12 fw-400" style={{ color: "#66737E", marginLeft: 10 }}>
                                Trips: <span style={{ color: "#3469E7" }}>{i.code}</span>
                              </div>
                            </div>
                          </div>

                          {/* AMOUNT */}
                          <div className="fs-14 fw-500" style={{ color: "#2C8C53" }}>
                            ₹{amount}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </Col>
          </Row>
          <Row className="align-items-center mb-2 mt-3">
            <Col md={12}>
              <div
                className="p-4 shadow-sm "
                style={{
                  borderRadius: "20px",
                  backgroundColor: "#FFFFFF",
                  border: "1px solid #EBEBEB",
                }}
              >
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div className="fw-bold m-0 fs-16 fw-700">Cost overview</div>
                  <div className="d-flex bg-light p-2 rounded-pill gap-2" style={{ width: "fit-content" }}>
                    <div
                      className={`px-4 py-1 rounded-pill ${activeTab === "fuel" ? "text-primary" : "text-secondary"}`}
                      style={{
                        background: activeTab === "fuel" ? "#FFFFFF" : "transparent",
                        fontWeight: 600,
                        cursor: "pointer",
                      }}
                      onClick={() => setActiveTab("fuel")}
                    >
                      Fuel cost
                    </div>
                    <div
                      className={`px-4 py-1 ${activeTab === "fastag" ? "text-primary rounded-pill" : "text-secondary"}`}
                      style={{
                        background: activeTab === "fastag" ? "#FFFFFF" : "transparent",
                        fontWeight: 600,
                        cursor: "pointer",
                      }}
                      onClick={() => setActiveTab("fastag")}
                    >
                      Fastag cost
                    </div>
                    <div
                      className={`px-4 py-1 ${activeTab === "other" ? "text-primary rounded-pill" : "text-secondary"}`}
                      style={{
                        background: activeTab === "other" ? "#FFFFFF" : "transparent",
                        fontWeight: 600,
                        cursor: "pointer",
                      }}
                      onClick={() => setActiveTab("other")}
                    >
                      Other cost
                    </div>
                  </div>
                  <YearPicker selectedYear={selectedVendorYear} setSelectedYear={setSelectedVendorYear} />
                </div>
                <Bar data={costDatas} options={CostOptions} height={50} />
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
}
